import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ImportsPage } from "@/features/lead-imports/imports-page";

export const Route = createFileRoute("/_authenticated/$store/imports/")({
  validateSearch: z.object({ tab: z.enum(["api"]).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Lead imports · Rogue AI" }] }),
  component: ImportsPage,
});
